import StorageBox from "../Store/StorageBox.js";

class ChurchBaseUtils {
  constructor() {}

  getChurchName() {
    var ChurchName = StorageBox.getChurchName();
    if (ChurchName != null) {
      return ChurchName;
    } else {
      return "Public/Anonymous";
    }
  }

  getChurchIntroduction() {
    var ChurchIntroduction = StorageBox.getChurchIntroduction();
    if (ChurchIntroduction != null) {
      return ChurchIntroduction;
    } else {
      return "Public/Anonymous";
    }
  }

  getChurchImagesName() {
    var ChurchImagesName = StorageBox.getChurchImagesName();
    if (ChurchImagesName != null) {
      return ChurchImagesName;
    } else {
      return "Public/Anonymous";
    }
  }

  getChurchId() {
    var ChurchId = StorageBox.getChurchId();
    if (ChurchId != null) {
      return ChurchId;
    } else {
      return "Public/Anonymous";
    }
  }

  getChurchPersonCreate() {
    var ChurchPersonCreate = StorageBox.getChurchPersonCreate();
    if (ChurchPersonCreate != null) {
      return ChurchPersonCreate;
    } else {
      return "Public/Anonymous";
    }
  }

  getChurchUserJoin() {
    var ChurchUserJoin = StorageBox.getChurchUserJoin();
    console.log("ChurchBase - getChurchUserJoin:", ChurchUserJoin);

    // Ensure we always return an array
    if (Array.isArray(ChurchUserJoin)) {
      return ChurchUserJoin;
    }

    console.warn(
      "ChurchBase - userJoin is not an array, returning empty array"
    );
    return [];
  }
}

export default new ChurchBaseUtils();
